const config = {
  api_url: 'https://api.theukrainianbride.com',
  socket_url: 'https://chatsocket.redbini.com' /* "http://localhost:8081",*/,
  wss_url_view: 'wss://chatstreamview.redbini.com',
  wss_url: 'https://chatstream.redbini.com',
  site_url: 'https://theukrainianbride.com',
  googleAnalyticsKey: 'UA-99609233-1',
};

module.exports = config;
